export default __webpack_public_path__ + "static/media/companyIconDark.2f0075eb.svg";